import React from 'react';

import * as XLSX from 'xlsx';

// Components
import { PrimaryButton } from "../Decoration/Button";

const ExportExcelButton = (props) => {

    const JSONtoAOA_XLSX_Converter = (columnTitle, rowData) => {

        /**
         * columnTitle structure
         * [  {label: x, formatter: f}, {label: y, formatter: f}, ... {label: n, formatter: f}]
         * 
         * rowData structure
         * [ { x:X, y:Y, ..., n:N }... ]
         */

        const sheetData = []
        const firstRow = []

        columnTitle.length && columnTitle.filter(c => c.formatter).map(c => firstRow.push(c.label || c.title))
        firstRow.length && sheetData.push(firstRow)

        rowData?.map(r => {
            const rowArray = []

            columnTitle.map(c => {
                if(c?.formatter) {
                    rowArray.push(c.formatter(r))
                }
            })

            sheetData.push(rowArray)
        })
        
        return sheetData   

    }

    const exportFile = () => {
        const ws = XLSX.utils.aoa_to_sheet(JSONtoAOA_XLSX_Converter(props.sheetRow, props.sheetData));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, props.sheetName);
        /* generate XLSX file and send to client */
        XLSX.writeFile(wb, `${props.filename}.xlsx`);
    }

    return (
        <>
            <PrimaryButton
                {...props.otherProps}
                disabled={props.disabled}
                onClick={exportFile}
            >
                Export
            </PrimaryButton>
        </>
    )
}


export default ExportExcelButton;